export enum DocumentType {
  DIGITAL_SIGNATURE = 'digital_signature',
  LEGAL_DOCUMENTS = 'legal_documents',
}

export enum DocumentGroupName {
  LANDA = 'LANDA',
  SUBSCRIPTION_AGREEMENTS = 'SUBSCRIPTION_AGREEMENTS',
  TRANSFER_AGENT = 'TRANSFER_AGENT',
  TAXES = 'TAXES',
  INVESTMENT_DOCUMENTS = 'INVESTMENT_DOCUMENTS',
  LEASES = 'Leases',
}

export type GraphQLDocumentObjectType = {
  dateCreated: string;
  documentUri: string;
  documentLabel: string;
  groupName: DocumentGroupName;
};

export interface GraphQLLeaseDocumentObjectType {
  rentLeaseId: string;
  dateSigned: string;
  documentUri: string;
}

export type DocumentObjectType = {
  type: DocumentType;
  id: string;
  attributes: DocumentObjectAttributesType;
  relationships?: {
    document: {
      data: {
        id: string;
        type: DocumentType;
      };
    };
  };
};

export type DocumentObjectAttributesType = {
  authorized_signature: string;
  date_signed: Date;
  document_label: string;
  document_uri: string;
  group_name: DocumentGroupName;
  legal_document_id: string;
  rent_lease_id?: string;
  signing_landa_user_id: string;
};
